import type { ReactNode } from 'react';

import {
  SeedlingDependenciesContextProvider,
  useSeedlingDependenciesContext,
} from '@grow-therapy-team/seedling-components';

import { useIntakeSummaryExperiment } from './useIntakeSummaryExperiment';

interface IntakeSummarySeedlingDependenciesProviderProps {
  children: ReactNode;
}

/**
 * Re-provides seedling dependencies with delayed-experiment experience injected
 * so IntakeSummaryConnected can gate on treatment (or the testing override flag).
 */
export function IntakeSummarySeedlingDependenciesProvider({
  children,
}: IntakeSummarySeedlingDependenciesProviderProps): JSX.Element {
  const dependencies = useSeedlingDependenciesContext();

  return (
    <SeedlingDependenciesContextProvider value={{ ...dependencies, useIntakeSummaryExperiment }}>
      {children}
    </SeedlingDependenciesContextProvider>
  );
}
